/**
 * This model describes the state of the client side session.
 */
import { createFeatureSelector } from "@ngrx/store";

export const SESSION_COMMON_STATE_NAME = "session";

export interface SessionState {
    /**
     * It tells how much time in seconds is left from the session if the user is inactive.
     */
    remainingTime: number;
    /**
     * It shows the remaining time in seconds till the next revive call.
     */
    reviveNeededIn: number;

    /**
     * If this property is true, then some kind of serious problem occurred in the application end the session must be
     * ended by initiating the normal logout process.
     */
    fatalError?: boolean;

    sessionTime?: number;
    warningTimeOut?: number;
}

export const selectSessionState = createFeatureSelector<any, SessionState>(SESSION_COMMON_STATE_NAME);

